import { cn } from "@/shared/lib";

export interface SettingRowProps {
  /**
   * 設定項目のラベル（文字列またはReactノード）
   */
  label?: React.ReactNode;
  /**
   * 設定のコントロール部分（Toggle、Select等）
   */
  children?: React.ReactNode;
  /**
   * オプションの説明文
   */
  description?: string | React.ReactNode;
  /**
   * カスタムクラス名
   */
  className?: string;
}

/**
 * 設定画面用の行コンポーネント
 * ラベルとコントロールを左右に配置し、オプションで説明文を表示
 */
export const SettingRow: React.FunctionComponent<SettingRowProps> = ({
  label,
  children,
  description,
  className,
}: SettingRowProps) => {
  return (
    <div
      className={cn(
        "flex flex-wrap items-center justify-between gap-x-3 px-4",
        description ? "pt-3" : "py-3",
        className,
      )}
    >
      {label && <p className="text-sm text-foreground">{label}</p>}
      {children}
      {description && (
        <p className="mt-2 basis-full pb-3 text-sm text-muted-foreground">
          {description}
        </p>
      )}
    </div>
  );
};
